import _ from 'lodash';
import { DefaultDecimalPoints, DefaultLaneNumber, PromiseAllSettledSuccessStatus } from 'services/constants';

const aggregateDelimiter = '--agg--';
const fromAggregateName = (aggregateName) => aggregateName.split(aggregateDelimiter);

export const toTSITimespan = (timespan) => {
  const from = formatToPostgresDatetime(timespan.from.toUTC());
  const to = formatToPostgresDatetime(timespan.to.toUTC());

  return {
    from: from,
    to: to
  };
};

const formatToPostgresDatetime = (datetime) => {
  const date = new Date(datetime);
  return date.toISOString();
};

export const convertTsiDataToGraphData = (tsiData, assetSignals) => {
  const items = tsiData.status === PromiseAllSettledSuccessStatus ? tsiData.value.items : [];
  const graphData = _.map(items, prop => {
    const propNameAndAggregate = fromAggregateName(prop.name);
    const propGroup = {
      assetId: assetSignals.assetId,
      name: propNameAndAggregate[0],
      data: []
    };

    if (propNameAndAggregate.length === 2) {
      propGroup.aggregate = propNameAndAggregate[1];
    }
    propGroup.data = _.map(prop.items, item =>
      [
        new Date(item.timestamp).getTime(),
        item.value
      ]
    );

    return propGroup;
  });

  const transformedGraphData = graphData.map(data => {
    const index = assetSignals.signals.findIndex(signal => signal.name === data.name);
    const hasFound = index >= 0;

    return {
      ...data,
      laneNumber: hasFound ? assetSignals.signals[index].laneNumber : DefaultLaneNumber,
      color: assetSignals.signals[index].color,
      decimalPoint: assetSignals.signals[index].decimalPoint || DefaultDecimalPoints,
      type: assetSignals.signals[index].type,
      fullName: assetSignals.signals[index].fullName
    };
  });

  return transformedGraphData;
};

export const createAggregatedRequestData = (assetSignals, timespan, aggregate) => {
  timespan = toTSITimespan(timespan);
  const signals = _.map(assetSignals.signals, s => s.name);

  return {
    assetId: assetSignals.assetId,
    timeseriesName: signals,
    whereClause: '',
    searchSpanFrom: timespan.from,
    searchSpanTo: timespan.to,
    aggregationType: assetSignals.signals[0].aggregates[0],
    aggregationInterval: aggregate
  };
};
